<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>

        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      url: 'link-1'
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              <h2
                class="text-justify text-center mt-3"
                style="color: #6c757d;"
              >Inprocess training(s)</h2>
              <!-- Inprocess training starts -->

              <div>
                <vs-tabs alignment="fixed" :color="colorx">
                  <vs-tab @click="colorx = '#06a6e0'" label="Trainer">
                    <div class="con-tab-ejemplo">
                      <div class="table-responsive">
                        <table class="table table-stripped">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Contact Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="trainer in Trainers" :key="trainer">
                              <td class="text-capitalize">{{material.title}}</td>
                              <td class="text-capitalize">{{material.type}}</td>
                              <td class="text-capitalize">{{material.fileType}}</td>
                              <td class="text-capitalize">{{material.uploadfile}}</td>
                              <td>{{material.createdAt}}</td>
                              <td>
                                <vs-icon icon="edit" color="warning" style="font-size:16px"></vs-icon>
                                <vs-icon
                                  icon="delete_forever"
                                  style="color:#ff0000c7;font-size:16px;cursor: pointer;"
                                ></vs-icon>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab @click="colorx = '#06a6e0'" label="Agenda">
                    <div class="con-tab-ejemplo">
                      <div>
                        <b-table responsive striped hover :items="agenda"></b-table>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab @click="colorx = '#06a6e0'" label="Knowledge Base">
                    <div class="con-tab-ejemplo">
                      <div class="mt-2">
                        <b-card no-body style="border:none !important;">
                          <b-tabs pills card vertical>
                            <b-tab
                              :title-item-class="'tab-title-class'"
                              disabled
                              title="Filter by"
                              style
                            ></b-tab>
                            <b-tab title="Presentations" active>
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="Presentation(s)" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="Word">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="Word Documents" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="PDF">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="PDF" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="Html Links">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="Html Links" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="Videos">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="Videos" color="success"></vs-list-header>
                                      <p>Videos</p>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab disabled title="Filter by Year"></b-tab>
                            <b-tab title="2019">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="2019" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="2018">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="2018" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="2017">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="2017" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>

                            <b-tab disabled title="Filter by Type"></b-tab>
                            <b-tab title="Pre Training">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="Pre Training" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="In Training">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="In Training" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                            <b-tab title="Reference Material">
                              <b-card-text>
                                <div class="col-sm-12">
                                  <div class="tab-item">
                                    <vs-list>
                                      <vs-list-header title="Reference Material" color="success"></vs-list-header>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                      <vs-list-item
                                        title="Global Training for prevention techniques against drug"
                                        subtitle="23-2-1019"
                                        class="hvr"
                                      >
                                        <i
                                          class="material-icons"
                                          style="font-size:28px;color:#4285f4"
                                        ></i>
                                      </vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </b-card-text>
                            </b-tab>
                          </b-tabs>
                        </b-card>
                        <vs-pagination :total="30" v-model="currentx"></vs-pagination>
                      </div>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </div>
              <!-- Inprocess training Ends -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
export default {
  data: () => ({
    colorx: "#06a6e0",
    Trainers: [],
    trainer: [
      {
        first_name: "Dickerson",
        email: "dickerson@gmail.com",
        contact_number: "00923219943774"
      },
      {
        first_name: "Larsen",
        email: "larsen@gmail.com",
        contact_number: "00923219943774"
      },
      {
        first_name: "Geneva",
        email: "geneva@gmail.com",
        contact_number: "00923219943774"
      },
      {
        first_name: "Jami",
        email: "jami@gmail.com",
        contact_number: "00923219943774"
      }
    ],
    agenda: [
      {
        total_no_of_days: "2",
        from_time: "09:00 am",
        to_time: "10:00 am",
        by: "Dr.Naveed"
      },
      {
        total_no_of_days: "5",
        from_time: "09:00 am",
        to_time: "10:00 am",
        by: "Ayesha Riaz"
      },
      {
        total_no_of_days: "7",
        from_time: "09:00 am",
        to_time: "10:00 am",
        by: "Muhammad Ammad"
      }
    ]
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    /* axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/traing_material/get/" +
          JSON.parse(localStorage.getItem("currentUser")).id +
          ""
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.materialRecords = response.data;
      }); */
    // Set the initial number of items
    // this.totalRows = this.items.length;
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.active {
  background: #fff !important;
  /* color:#fff !important; */
}
</style>

